import { render, staticRenderFns } from "./FbTopSidebar.vue?vue&type=template&id=40ee2fec&"
import script from "./FbTopSidebar.vue?vue&type=script&lang=js&"
export * from "./FbTopSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports